import IconButton from "@/read-ui/IconButton";
import Icon from "@/read-ui/Icon";
import ChapterItem from "../ChapterItem";
import { IRenderItem, generateList } from "../../utils";
import { SortOutline } from "@webnovel/chereads-icons";
import { useEffect, useRef, useState } from "react";
import { IChapterListPageTypes } from "../../interfaces";
import { rem } from "@/utils/adaptor";
import styles from "./index.module.scss";
import { BookTypeEnum } from "@/interface/IBook";
import { chapterListUrl } from "@/utils/URL";
import Link from "next/link";

const DATA_LIST_ITEM = "volumeName";

export type ChapterItemsProps = {
  isPureId?: boolean;
  // 只展示出来的所有的章节（源码里能看到隐藏的章节）
  initVisibleCount?: number;
  // 截断章节列表展示的个数（源码里看不到多余的章节）
  realCount?: number;
  novelType?: BookTypeEnum;
  className?: string;
  Component?: any;
} & IChapterListPageTypes;

const ChapterItems = (props: ChapterItemsProps) => {
  const {
    bookInfo,
    Component = "h1",
    isPureId = false,
    volumeItems,
    lastChapterItem,
    curReadChapter,
    initVisibleCount = 0,
    realCount = 0,
    novelType = BookTypeEnum.Novel,
    className,
  } = props;

  const { bookId = "", bookName = "" } = bookInfo;
  const [isRevert, setIsRevert] = useState<boolean>(false);
  const listRef = useRef<HTMLUListElement>(null);
  const [showMoreBtn, setShowMoreBtn] = useState(
    Boolean(initVisibleCount) &&
      Math.min(
        volumeItems?.reduce?.((a1, b1) => a1 + b1.chapterItems.length, 0) ?? 0,
        realCount || Number.MAX_SAFE_INTEGER
      ) > initVisibleCount
  );

  useEffect(() => {
    if (listRef.current && initVisibleCount) {
      // 找到第 visibleCount 个章节的dom，获取它的offsetTop，设置为整个列表的高度
      const listChildren = listRef.current.children;
      let count = 0;
      for (let i = 0; i < listChildren.length; i++) {
        const child = listChildren[i];

        if (child.getAttribute("data-list-item") !== DATA_LIST_ITEM) {
          count += 1;
        }

        if (count > initVisibleCount) {
          listRef.current.style.maxHeight = `${rem(child.offsetTop - 8)}rem`;
          break;
        }
      }
    }
  }, [initVisibleCount]);

  if (!volumeItems?.length) {
    return null;
  }

  const { list } = generateList({
    volumeItems,
    bookInfo,
    curReadChapter,
    revert: isRevert,
  });

  const handleRenderContent = () => {
    let count = 0;

    const renderContent = (item: IRenderItem) => {
      if (realCount > 0 && count >= realCount) {
        return null;
      }

      const isCurrent =
        "chapterId" in item && item?.chapterId === curReadChapter;
      if (!item) {
        return null;
      }
      let content = null;
      if ("isVolume" in item && item?.isVolume) {
        content = (
          <h3
            key={item.volumeId}
            className={`mt16 fs14 c_m lh20`}
            data-list-item={DATA_LIST_ITEM}
          >
            Volume {item.volumeId}{" "}
            {item.volumeName ? `:${item.volumeName}` : ""}
          </h3>
        );
      }
      // if ("isPrivilegeCard" in item && item?.isPrivilegeCard) {
      //   content = <PrivilegeCard key={index} dark={dark} />;
      // }
      if ("chapterId" in item && item.chapterId) {
        count += 1;
        content = (
          <li key={item.chapterId}>
            <ChapterItem
              key={item.chapterId}
              chapterInfo={item}
              isCurrent={isCurrent}
              bookId={bookId}
              bookName={bookName}
              isPureId={isPureId}
              novelType={novelType}
            />
          </li>
        );
      }
      return content;
    };

    return list?.map((item: IRenderItem) => renderContent(item));
  };

  return (
    <div className={className}>
      <div className="mb16 mt16 pr df aic jcc mr-16">
        <Component className={"t_h6 c_l f1"}>Table of contents</Component>
        <IconButton
          ghost
          icon={<Icon Svg={SortOutline} size={20} />}
          onClick={() => setIsRevert((pre) => !pre)}
        />
      </div>
      {lastChapterItem && (
        <div>
          <strong className={"fs14 lh20 c_m"}>Latest Update</strong>
          <ChapterItem
            chapterInfo={lastChapterItem}
            bookId={bookId}
            bookName={bookName}
            isPureId={isPureId}
          />
        </div>
      )}
      <ul ref={listRef} className={styles.list}>
        {handleRenderContent()}
      </ul>
      {showMoreBtn && (
        <div
          // href={chapterListUrl({
          //   novelType,
          //   bookId,
          // })}
          onClick={() => setShowMoreBtn(true)}
          className={styles.moreBtn}
        >
          VIEW MORE
        </div>
      )}
    </div>
  );
};

export default ChapterItems;
